import { useLocation } from 'react-router-dom';
import { CLASSIC_ADMIN_PREFIX, ENTERPRISE_ADMIN_BASE } from '../config/adminLayers';

/** Classic `/admin/*` vs enterprise `/admin/app/*` base for building settings URLs. */
export function useAdminBasePath(): string {
  const { pathname } = useLocation();
  return pathname.startsWith(ENTERPRISE_ADMIN_BASE) ? ENTERPRISE_ADMIN_BASE : CLASSIC_ADMIN_PREFIX;
}
